import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Сотрудники — MOVED to `/profile/users`.
 *
 * The old panel reached its staff screen from the profile page, and this route
 * was a temporary home for it under the delivery namespace. The roster is now
 * one merchant-wide screen at `/profile/users` (the identities it lists work
 * across every sub-app), so this path only forwards.
 *
 * Kept as a redirect rather than deleted outright: it was a first-class nav
 * item, so a bookmark or an open tab pointing here is plausible.
 */
export const Route = createFileRoute('/delivery/staff')({
  beforeLoad: () => {
    // `redirect()` is TanStack Router's control-flow throw, not an Error —
    // same exemption as `require-auth.ts`.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/profile/users', replace: true });
  },
});
